import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Header } from '../../components/layout/Header';
import { Footer } from '../../components/layout/Footer';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { QrCode, CheckCircle, MapPin, Calendar, Users, Clock, Camera, Loader2, AlertCircle, PartyPopper, Share2, Download, Smartphone } from 'lucide-react';
interface EventInfo {
  id: string;
  name: string;
  date: string;
  time: string;
  location: string;
  address: string;
  totalParticipants: number;
  targetParticipants: number;
  status: 'active' | 'upcoming' | 'ended';
}
const mockEvent: EventInfo = {
  id: 'hpsn-2024',
  name: 'HPSN 2024: Atasi Sampah Plastik',
  date: '21 Februari 2024',
  time: '07:00 - 12:00 WIB',
  location: 'Pantai Ancol, Jakarta Utara',
  address: 'Jl. Lodan Timur No.7, Ancol, Pademangan',
  totalParticipants: 1250,
  targetParticipants: 2000,
  status: 'active'
};
export function EventCheckinPage() {
  const {
    eventId
  } = useParams();
  const [step, setStep] = useState<'info' | 'form' | 'verifying' | 'success'>('info');
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    organization: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [checkinCode, setCheckinCode] = useState('');
  const handleCheckin = () => {
    setStep('verifying');
    setIsLoading(true);
    // Simulate verification
    setTimeout(() => {
      setIsLoading(false);
      setCheckinCode('CHK-' + Math.random().toString(36).substring(2, 8).toUpperCase());
      setStep('success');
    }, 2000);
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'active':
        return <Badge className="bg-green-100 text-green-700 border-green-200 gap-1" data-id="element-3954">
            <span className="h-2 w-2 rounded-full bg-green-500 animate-pulse" data-id="element-3955" />
            Sedang Berlangsung
          </Badge>;
      case 'upcoming':
        return <Badge className="bg-blue-100 text-blue-700 border-blue-200" data-id="element-3956">
            Akan Datang
          </Badge>;
      case 'ended':
        return <Badge className="bg-gray-100 text-gray-700 border-gray-200" data-id="element-3957">
            Selesai
          </Badge>;
      default:
        return null;
    }
  };
  if (step === 'success') {
    return <div className="min-h-screen bg-gradient-to-br from-primary-600 to-secondary-700 flex flex-col font-sans" data-id="element-3958">
        <div className="flex-1 flex items-center justify-center p-4" data-id="element-3959">
          <Card className="w-full max-w-md border-0 shadow-2xl animate-in zoom-in duration-500" data-id="element-3960">
            <CardContent className="p-8 text-center" data-id="element-3961">
              <div className="h-24 w-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-3962">
                <CheckCircle className="h-12 w-12 text-green-600" data-id="element-3963" />
              </div>

              <PartyPopper className="h-8 w-8 text-yellow-500 mx-auto mb-4" data-id="element-3964" />

              <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-3965">
                Check-in Berhasil!
              </h1>
              <p className="text-gray-600 mb-6" data-id="element-3966">
                Selamat datang di {mockEvent.name}
              </p>

              <div className="bg-gray-50 rounded-xl p-6 mb-6" data-id="element-3967">
                <p className="text-sm text-gray-500 mb-2" data-id="element-3968">Kode Check-in Anda</p>
                <p className="text-3xl font-mono font-bold text-primary-700 tracking-wider" data-id="element-3969">
                  {checkinCode}
                </p>
                <p className="text-xs text-gray-400 mt-2" data-id="element-3970">
                  Tunjukkan kode ini kepada panitia jika diperlukan
                </p>
              </div>

              <div className="bg-primary-50 rounded-lg p-4 mb-6 text-left" data-id="element-3971">
                <h3 className="font-medium text-primary-900 mb-2" data-id="element-3972">
                  Informasi Penting:
                </h3>
                <ul className="text-sm text-primary-700 space-y-1" data-id="element-3973">
                  <li data-id="element-3974">• Kumpul di Posko Utama pukul 07:00</li>
                  <li data-id="element-3975">• Bawa botol minum sendiri</li>
                  <li data-id="element-3976">• Gunakan pakaian nyaman & sepatu tertutup</li>
                </ul>
              </div>

              <div className="flex gap-3" data-id="element-3977">
                <Button variant="outline" className="flex-1 gap-2" data-id="element-3978">
                  <Share2 className="h-4 w-4" data-id="element-3979" />
                  Bagikan
                </Button>
                <Button variant="outline" className="flex-1 gap-2" data-id="element-3980">
                  <Download className="h-4 w-4" data-id="element-3981" />
                  Simpan
                </Button>
              </div>

              <Link to={`/event/${eventId}`} className="block mt-4" data-id="element-3982">
                <Button variant="ghost" className="w-full text-gray-500" data-id="element-3983">
                  Kembali ke Detail Event
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>;
  }
  if (step === 'verifying') {
    return <div className="min-h-screen bg-gradient-to-br from-primary-600 to-secondary-700 flex flex-col font-sans" data-id="element-3984">
        <div className="flex-1 flex items-center justify-center p-4" data-id="element-3985">
          <Card className="w-full max-w-md border-0 shadow-2xl" data-id="element-3986">
            <CardContent className="p-8 text-center" data-id="element-3987">
              <div className="h-24 w-24 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-3988">
                <Loader2 className="h-12 w-12 text-primary-600 animate-spin" data-id="element-3989" />
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-3990">
                Memverifikasi...
              </h2>
              <p className="text-gray-600" data-id="element-3991">
                Mohon tunggu, kami sedang memproses check-in Anda
              </p>
            </CardContent>
          </Card>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 flex flex-col font-sans" data-id="element-3992">
      <Header data-id="element-3993" />

      <main className="flex-1" data-id="element-3994">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary-600 to-secondary-700 text-white py-12" data-id="element-3995">
          <div className="container mx-auto px-4 md:px-6" data-id="element-3996">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-3997">
              <QrCode className="h-8 w-8" data-id="element-3998" />
              <h1 className="text-2xl md:text-3xl font-bold" data-id="element-3999">Event Check-in</h1>
            </div>
            <p className="text-center text-white/80 max-w-md mx-auto" data-id="element-4000">
              Scan QR Code atau isi form untuk check-in ke event
            </p>
          </div>
        </section>

        <div className="container mx-auto px-4 md:px-6 py-8 max-w-lg" data-id="element-4001">
          {step === 'info' && <div className="space-y-6 animate-in fade-in duration-300" data-id="element-4002">
              {/* Event Info Card */}
              <Card className="overflow-hidden" data-id="element-4003">
                <div className="h-32 bg-gradient-to-r from-primary-500 to-secondary-500 relative" data-id="element-4004">
                  <div className="absolute inset-0 bg-black/20" data-id="element-4005" />
                  <div className="absolute bottom-4 left-4 right-4" data-id="element-4006">
                    {getStatusBadge(mockEvent.status)}
                  </div>
                </div>
                <CardContent className="p-6" data-id="element-4007">
                  <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-4008">
                    {mockEvent.name}
                  </h2>

                  <div className="space-y-3 text-sm" data-id="element-4009">
                    <div className="flex items-start gap-3" data-id="element-4010">
                      <Calendar className="h-5 w-5 text-gray-400 flex-shrink-0" data-id="element-4011" />
                      <div data-id="element-4012">
                        <p className="font-medium text-gray-900" data-id="element-4013">
                          {mockEvent.date}
                        </p>
                        <p className="text-gray-500" data-id="element-4014">{mockEvent.time}</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-4015">
                      <MapPin className="h-5 w-5 text-gray-400 flex-shrink-0" data-id="element-4016" />
                      <div data-id="element-4017">
                        <p className="font-medium text-gray-900" data-id="element-4018">
                          {mockEvent.location}
                        </p>
                        <p className="text-gray-500" data-id="element-4019">{mockEvent.address}</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-4020">
                      <Users className="h-5 w-5 text-gray-400 flex-shrink-0" data-id="element-4021" />
                      <div data-id="element-4022">
                        <p className="font-medium text-gray-900" data-id="element-4023">
                          {mockEvent.totalParticipants.toLocaleString()} Peserta
                        </p>
                        <p className="text-gray-500" data-id="element-4024">
                          Target:{' '}
                          {mockEvent.targetParticipants.toLocaleString()}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Progress */}
                  <div className="mt-4 pt-4 border-t" data-id="element-4025">
                    <div className="flex justify-between text-sm mb-2" data-id="element-4026">
                      <span className="text-gray-500" data-id="element-4027">Partisipasi</span>
                      <span className="font-medium text-gray-900" data-id="element-4028">
                        {Math.round(mockEvent.totalParticipants / mockEvent.targetParticipants * 100)}
                        %
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-4029">
                      <div className="bg-primary-600 h-2 rounded-full transition-all" style={{
                    width: `${mockEvent.totalParticipants / mockEvent.targetParticipants * 100}%`
                  }} data-id="element-4030" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Check-in Options */}
              <div className="space-y-4" data-id="element-4031">
                <h3 className="font-medium text-gray-900 text-center" data-id="element-4032">
                  Pilih Metode Check-in
                </h3>

                <Button className="w-full h-14 bg-primary-600 hover:bg-primary-700 gap-3 text-lg" onClick={() => setStep('form')} data-id="element-4033">
                  <Smartphone className="h-5 w-5" data-id="element-4034" />
                  Isi Form Check-in
                </Button>

                <div className="relative" data-id="element-4035">
                  <div className="absolute inset-0 flex items-center" data-id="element-4036">
                    <div className="w-full border-t border-gray-200" data-id="element-4037" />
                  </div>
                  <div className="relative flex justify-center text-sm" data-id="element-4038">
                    <span className="px-4 bg-gray-50 text-gray-500" data-id="element-4039">atau</span>
                  </div>
                </div>

                <Card className="border-2 border-dashed border-gray-300 hover:border-primary-400 transition-colors cursor-pointer" data-id="element-4040">
                  <CardContent className="p-6 text-center" data-id="element-4041">
                    <Camera className="h-10 w-10 text-gray-400 mx-auto mb-3" data-id="element-4042" />
                    <p className="font-medium text-gray-900 mb-1" data-id="element-4043">
                      Scan QR Code
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-4044">
                      Arahkan kamera ke QR Code yang tersedia di lokasi
                    </p>
                  </CardContent>
                </Card>
              </div>
            </div>}

          {step === 'form' && <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-4045">
              <Card data-id="element-4046">
                <CardContent className="p-6" data-id="element-4047">
                  <h2 className="text-lg font-bold text-gray-900 mb-4" data-id="element-4048">
                    Form Check-in
                  </h2>

                  <div className="space-y-4" data-id="element-4049">
                    <div data-id="element-4050">
                      <label className="text-sm font-medium text-gray-700 mb-1 block" data-id="element-4051">
                        Nama Lengkap <span className="text-red-500" data-id="element-4052">*</span>
                      </label>
                      <Input placeholder="Masukkan nama lengkap" value={formData.name} onChange={e => setFormData({
                    ...formData,
                    name: e.target.value
                  })} data-id="element-4053" />
                    </div>

                    <div data-id="element-4054">
                      <label className="text-sm font-medium text-gray-700 mb-1 block" data-id="element-4055">
                        No. HP <span className="text-red-500" data-id="element-4056">*</span>
                      </label>
                      <Input type="tel" placeholder="08xxxxxxxxxx" value={formData.phone} onChange={e => setFormData({
                    ...formData,
                    phone: e.target.value
                  })} data-id="element-4057" />
                    </div>

                    <div data-id="element-4058">
                      <label className="text-sm font-medium text-gray-700 mb-1 block" data-id="element-4059">
                        Email (Opsional)
                      </label>
                      <Input type="email" placeholder="email@example.com" value={formData.email} onChange={e => setFormData({
                    ...formData,
                    email: e.target.value
                  })} data-id="element-4060" />
                    </div>

                    <div data-id="element-4061">
                      <label className="text-sm font-medium text-gray-700 mb-1 block" data-id="element-4062">
                        Organisasi/Komunitas (Opsional)
                      </label>
                      <Input placeholder="Nama organisasi atau komunitas" value={formData.organization} onChange={e => setFormData({
                    ...formData,
                    organization: e.target.value
                  })} data-id="element-4063" />
                    </div>
                  </div>

                  <div className="mt-6 p-3 bg-yellow-50 border border-yellow-200 rounded-lg flex gap-3" data-id="element-4064">
                    <AlertCircle className="h-5 w-5 text-yellow-600 flex-shrink-0" data-id="element-4065" />
                    <p className="text-sm text-yellow-800" data-id="element-4066">
                      Pastikan Anda sudah berada di lokasi event saat melakukan
                      check-in.
                    </p>
                  </div>
                </CardContent>
              </Card>

              <div className="flex gap-3" data-id="element-4067">
                <Button variant="outline" className="flex-1" onClick={() => setStep('info')} data-id="element-4068">
                  Kembali
                </Button>
                <Button className="flex-1 bg-primary-600 hover:bg-primary-700" onClick={handleCheckin} disabled={!formData.name || !formData.phone} data-id="element-4069">
                  Check-in Sekarang
                </Button>
              </div>
            </div>}
        </div>
      </main>

      <Footer data-id="element-4070" />
    </div>;
}